// extracted by mini-css-extract-plugin
module.exports = {"panel__asset":"styles_panel__asset__kZ207","panelReverse":"styles_panelReverse__Ew9Ax"};